export default __webpack_public_path__ + "static/benefitSectionBg-c5b7a1cb0b73a6224cdb4fbc919ab805.png";